export default "__VITE_ASSET__CBv_0AaQ__"